import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-swk-edit-account',
    templateUrl: 'dialog.editaccount.html',
    styleUrls: ['dialog.editaccount.css']
})
export class EditAccountPukalSarawakGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    loading: boolean = true;
    isSubmit: boolean = false;
    editaccform: FormGroup;
    errorMessage: string = '';
    objects = [];
    creationDate: any;
    activationDate: any;
    lastModifiedDate: any;
    terminationDate: any;
    createdUserId: any;
    userId: any;
    screenCode: string = '';

    constructor(public dialogRef: MatDialogRef<EditAccountPukalSarawakGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public accData: any,
        private fb: FormBuilder,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.editaccform = new FormGroup({
            agencyName: new FormControl({ value: '', disabled: true }),
            accNo: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(15)]),
            ptjCode: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(9)]),
            description: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(500)]),
            email: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.required, Validators.maxLength(50)]),
            accSts: new FormControl({ value: '', disabled: true }),
            rcdSts: new FormControl({ value: '', disabled: true })
        });

        this.screenCode = this.accData.screenCode;
        let agencyCode = this.accData.selectedAcc.Airline_Agency_Code;
        let accoffCode = this.accData.selectedAcc.Acc_Off_Code;
        let accnumber = this.accData.selectedAcc.Acc_No;

        let init_sub = this.managePukalService.initEditSWKPukalAccountDetails(this.accData.selectedAcc.Auto_No)
            .subscribe(
                (value) => {
                    this.loading = false;
                    if (value.status === 204) {

                    } else if (value.status === 200) {
                        this.loading = false;

                        this.editaccform.setValue({
                            agencyName: value.body['Agency_Name'],
                            accNo: value.body['Acc_No'],
                            ptjCode: value.body['PTJ_Code'],
                            description: value.body['Description'],
                            email: value.body['Email'],
                            accSts: value.body['Acc_Sts'],
                            rcdSts: value.body['Rcd_Sts']
                        });

                        this.creationDate = value.body['Creation_Date'];
                        this.activationDate = value.body['Activation_Date'];
                        this.lastModifiedDate = value.body['Sys_Date'];
                        this.terminationDate = value.body['Termination_Date'];
                        this.createdUserId = value.body['Created_User_Id'];
                        this.createdUserId = value.body['Created_User_Id'];
                        this.userId = value.body['User_Id'];
                    } else {

                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.isSubmit = true;

            let pukalAccount = {
                Acc_No: this.editaccform.get('accNo')!.value,
                Description: this.editaccform.get('description')!.value,
                Email: this.editaccform.get('email')!.value,
                PTJ_Code: this.editaccform.get('ptjCode')!.value,
                Auto_No: this.accData.selectedAcc.Auto_No
            }

            let save_sub = this.managePukalService.updateSWKPukalAccountDetails(pukalAccount)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            this.dialogRef.close('Edit successful');
                        } else {
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}